import {
  SelectTabData,
  SelectTabEvent,
  Tab,
  TabList,
  TabValue,
} from "@fluentui/react-components";
import { SelectedTabEnum } from "../../enum/app-settings/AppSettingsEnum";

interface IAppSettingsTabsProps {
  appSettingsTabs: { id: SelectedTabEnum; label: string }[];
  selectedTab: TabValue;
  onTabSelect: (event: SelectTabEvent, data: SelectTabData) => void;
}

const AppSettingsTabs: React.FC<IAppSettingsTabsProps> = ({
  appSettingsTabs,
  selectedTab,
  onTabSelect,
}) => {
  return (
    <TabList selectedValue={selectedTab} onTabSelect={onTabSelect} size="large">
      {appSettingsTabs.map((tab) => (
        <Tab key={tab.id} id={tab.id} value={tab.id}>
          {tab.label}
        </Tab>
      ))}
    </TabList>
  );
};

export default AppSettingsTabs;
